import {ISingleVoyage} from "@containers/singleVoyage/types/voyage";
import {IRouteInfoSingleVoyage} from "@containers/singleVoyage/types/route";

export const getRouteInfoFromSingleVoyage = (voyage: ISingleVoyage): IRouteInfoSingleVoyage => {
    const currentAssignment = voyage?.assignments?.find((item) => item?.isCurrent)
    return {
        title: voyage?.title,
        driverId: currentAssignment?.driverId,
        deviceId: currentAssignment?.deviceId,
        plannedStart: voyage?.plannedStart,
        plannedEnd: voyage?.plannedEnd,
        factStart: voyage?.factStart,
        factEnd: voyage?.factEnd,
        config: voyage?.config,
        id: voyage?.id,
        status: voyage?.voyageStatus,
    }
}